import { Utils, ViewHelpers } from "poly-js-utils";

export const phoneFormat = (phone, withFormatPreference) => {
    let link, readable;

    if (withFormatPreference) {
        link = ViewHelpers.phoneFormat(phone, false, true);
        readable = ViewHelpers.phoneFormat(phone, true, false);
    } else {
        link = Utils.stripNonDigits(phone);
        readable = phone;
    }

    return { link, readable };
};

export const formatHref = ViewHelpers.formatHref;



// WEBPACK FOOTER //
// ./common/utils.js